export class ApiError extends Error {
  constructor(public status: number, public body: { code?: string; message?: string; retryAfter?: number; issues?: Array<{ path: string; message: string }> } | null) {
    super(body?.message ?? `Request failed (${status})`)
  }
  get code() { return this.body?.code }
}

let csrf = ''
export const setCsrf = (t: string) => { csrf = t }
export const getCsrf = () => csrf

type Listener = () => void
const unauthListeners = new Set<Listener>()
/** Called when any request returns 401 UNAUTHENTICATED (session expired / logged out elsewhere). */
export const onUnauthenticated = (fn: Listener) => { unauthListeners.add(fn); return () => { unauthListeners.delete(fn) } }

export interface RequestOptions { method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'; body?: unknown; signal?: AbortSignal; form?: FormData }

export async function api<T = unknown>(path: string, opts: RequestOptions = {}): Promise<T> {
  const method = opts.method ?? 'GET'
  const headers: Record<string, string> = {}
  if (method !== 'GET') headers['X-CSRF-Token'] = csrf
  let body: BodyInit | undefined
  if (opts.form) body = opts.form
  else if (opts.body !== undefined) { headers['Content-Type'] = 'application/json'; body = JSON.stringify(opts.body) }

  const res = await fetch(`/api${path}`, { method, headers, body, credentials: 'include', signal: opts.signal })
  if (res.status === 204) return undefined as T
  const data = await res.json().catch(() => null)
  if (!res.ok) {
    const err = new ApiError(res.status, data)
    // /auth/me is how we *discover* the session state; reacting to its 401 would loop (clear -> refetch -> 401).
    if (res.status === 401 && err.code === 'UNAUTHENTICATED' && path !== '/auth/me') unauthListeners.forEach((fn) => fn())
    throw err
  }
  return data as T
}

export const qs = (params: Record<string, string | number | boolean | undefined | null>) => {
  const p = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v))
  const s = p.toString()
  return s ? `?${s}` : ''
}
